<template lang="pug">
  b-modal#configKey(
    ref="configKey"
    :title="$t('ui.key')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountId.toUpperCase()"
          readonly
        )
      .form-group
        label {{ $t("ui.suffix") }}
        DebounceInput(
          type="text"
          ref="suffix"
          :dirty="$v.suffix.$dirty"
          :error="$v.suffix.$error"
          :placeholder='$t("ui.suffix")'
          :minLength="$v.suffix.$params.minLength.min"
          :maxLength="$v.suffix.$params.maxLength.max"
          v-model.trim.lazy="$v.suffix.$model"
          :disabled="loading"
          :readonly="isNew == false"
        )
        ValidateResult(:value="$v.suffix" :name="$t('ui.suffix')")
      .form-group
        label {{ $t("ui.seamless") }}
        div.d-flex
          label.switch.switch-label.switch-success(style="margin: 5px 0 0 0;")
            input(type="checkbox" class="switch-input" v-model="seamless" :disabled="isNew == false")
            span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
        //- DebounceInput(
        //-   type="text"
        //-   ref="suffix"
        //-   :dirty="$v.suffix.$dirty"
        //-   :error="$v.suffix.$error"
        //-   :placeholder='$t("ui.suffix")'
        //-   :minLength="$v.suffix.$params.minLength.min"
        //-   :maxLength="$v.suffix.$params.maxLength.max"
        //-   v-model.trim.lazy="$v.suffix.$model"
        //-   :disabled="loading"
        //-   :readonly="isNew == false"
        //- )
        //- ValidateResult(:value="$v.suffix" :name="$t('ui.suffix')")
      .form-group(v-if="isNew == false")
        label {{ $t("ui.key") }}
        DebounceInput(
          type="text"
          ref="operator_key"
          :placeholder='$t("ui.key")'
          :value="operator_key"
          readonly
        )
      .form-group(v-if="seamless == true")
        label {{ $t("ui.callback_url") }}
        DebounceInput(
          type="text"
          ref="callbackurl"
          :dirty="$v.callbackurl.$dirty"
          :error="$v.callbackurl.$error"
          :placeholder='$t("ui.callback_url")'
          v-model.trim.lazy="$v.callbackurl.$model"
          :disabled="loading"
          :readonly="isNew == false"
        )
        small.text-muted.mr-2 {{ $t("message.only_allow_proper_url") }}
        ValidateResult(:value="$v.callbackurl" :name="$t('ui.callback_url')")
      .form-group
        label {{ $t("ui.email") }}
        DebounceInput(
          type="text"
          ref="email"
          :dirty="$v.email.$dirty"
          :error="$v.email.$error"
          :placeholder='$t("ui.email")'
          v-model.trim.lazy="$v.email.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.email" :name="$t('ui.email')")
      //- .form-group(v-if="isNew == false")
      //-   label {{ $t("ui.status") }}
      //-   b-form-select(
      //-     size="sm"
      //-     v-model="apistatus"
      //-     :disabled="isNew != false"
      //-   )
      //-     option(value="ACTIVE") {{ $t("ui.active") }}
      //-     option(value="INACTIVE") {{ $t("ui.inactive") }}
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxValue, minLength, maxLength, email, numeric, url, alphaNum, requiredIf } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    accountId: "",
    accountType: ""
  },
  data() {
    return {
      loading: false,
      suffix: "",
      seamless: false,
      callbackurl: "",
      email: "",
      operator_key: "",
      isNew: false,
      apistatus: 'ACTIVE',
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    suffix: {
      required,
      alphaNum,
      minLength: minLength(3),
      maxLength: maxLength(4)
    },
    callbackurl: {
      required : requiredIf(function () {
        return this.seamless == true;
      }),
      url
    },
    email: {
      email
    }
  },
  computed: {
  },
  mounted: function() {},
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getKeyList: function() {
      let account_id = this.accountId
      this.loading = true
      if(account_id) {
        this.$store
          .dispatch("user/getKeyList", { account_id })
          .then(response => {
            this.loading = false
            if(response.data.length > 0) {
              this.isNew = false
              this.suffix = response.data[0].suffix
              this.callbackurl = response.data[0].callbackurl
              this.seamless = response.data[0].type == 2 ? true : false
              this.email = response.data[0].email
              this.operator_key = response.data[0].key
              this.apistatus = response.data[0].status
            } else {
              this.isNew = true
            }
          })
          .catch(response => {
            console.log("Failed:getKeyList", response)
            this.loading = false
          });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      var invalid = false;
      if(this.isNew == false) {
        this.$v.callbackurl.$touch()
        this.$v.email.$touch()
        if(this.$v.callbackurl.$invalid == true || this.$v.email.$invalid == true) {
          invalid = true;
        }
      } else {
        this.$v.$touch()
        invalid = this.$v.$invalid;
      }

      // if (!this.$v.$invalid) {
      if (!invalid) {
        this.loading = true
        var msg = ""
        if(this.isNew == false) {
          msg = this.$t("message.update_key_confirm");
        } else if(this.isNew == true) {
          msg = this.$t("message.add_key_confirm");
        }

        this.$swal({
          title: this.$t("ui.status"),
          text: msg,
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            if(this.isNew == false) {
              this.updateKey();
            } else if(this.isNew == true) {
              this.addKey();
            }
          } else {
            this.loading = false
          }
        });
      }
    },
    addKey: function() {
      let account_id = this.accountId
      let suffix = this.suffix
      let type = this.seamless == true ? 2 : 1
      let callbackurl = this.callbackurl
      let email = this.email

      this.$store
        .dispatch("user/addKey", { account_id, suffix, type, callbackurl, email })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.add_key_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:addKey", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    updateKey: function() {
      let account_id = this.accountId
      let callbackurl = this.callbackurl
      let email = this.email
      let apistatus = this.apistatus

      this.$store
        .dispatch("user/updateKey", { account_id, callbackurl, email, apistatus })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_key_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateKey", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.full_name = ""
      this.suffix = ""
      this.callbackurl = ""
      this.email = ""
      this.operator_key = ""
      this.isNew = false
      this.apistatus = 'ACTIVE'
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
        this.getKeyList();
      });
    },
    cancel: function() {
      this.$refs.configKey.hide();
      this.$emit("clicked")
    }
  }
}
</script>